const dataPlanExtension = {
  dataPlanExtension: {
    heading: "Extensão de dados do Mobile Connect",
    cellModemIMEI: "Número IMEI do modem celular",
    siteName: "Nome do sistema",
    siteAddress: "Endereço do sistema",
    cellPlanEndDate: "Data de Fim do Plano de Modem Celular",
    daysToExpiry: "Dni do wygaśnięcia",
    currentPlanStatus: "Bieżący stan planu",
    gatewaySNo: "Gateway S.NO",
    paymentStatus: "Status płatności",
    lastDateOfPurchase: "Ostatnia data zakupu",
    extendDataPlan: "Rozszerz pakiet danych",
    purchasedBy: "Kupiony przez",
    purchasedFrom: "Kupiony od",
    siteId: "ID do sistema",
    orderNo: "número do pedido",
    footer: 'Extensão de dados do Mobile Connect',
    total: 'Całkowity',
    record: 'dokumentacja',
    records: 'dokumentacja',
    show: 'Pokazywać',
    enphase_store: 'Enphase Store',
    orderSummary: 'podsumowanie zamowienia.',
    confirmSelection: 'Potwierdź swój wybór poniżej',
    noOfCellModems: 'Liczba modemów komórkowych',
    years: 'Lata',
    pricePerSite: 'Cena za witrynę',
    cancel:'Anulować',
    submit:'Składać',
    back: 'Z powrotem',
    noTokens: '** Brak dostępnych modemów komórkowych **',
    redirectToStoreText: 'Redireccionando para a ENPHASE Store! Por favor, aguarde...!',
    toolTipExtensionInfo: 'Apenas os planos de modem celulares com menos de 180 dias para expirar são elegíveis para extensão.',
    allCellModems: 'Todos os modems celulares',
    dataplanTitleTooltip: 'This is an extension to Enphase monitoring, software/firmware upgrades, and other remote services offered via your existing AT&T cell modem. This extension will enable you to continue using the same physical hardware, beyond its 5-year term you had originally purchased, by renewing its connectivity instead of having to purchase a new physical device.',
    eligibleCellModems: 'Os modems celulares elegíveis',
    nonAdminInfo: 'Entre em contato com o administrador para estender o plano de dados para um modem celular',
    select: 'Selecione',
    typeToSearch: 'Escreva para pesquisar',
    dataPlanExtensionSuccess: "A  extensão de dados do mobile connect foi efectuada com êxito. Poderá demorar algum tempo até que o pagamento seja refletido no painel de controlo",
    expired: 'Expirado',
    active: 'Ativo',
    failed: "Pagamento falhado",
    pending: "Execução do pagamento",
    success: "Pagamento bem-sucedido",
  }
}

export default dataPlanExtension